/**
 * 联系我们页面。
 * 展示联系方式，并用腾讯地图标注公司位置。
 */
import React, { useState, useEffect } from 'react';
import CONFIG from '../../config'
import apiAboutLangjie from '../../api/apiAboutLangjie'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import FadeTransitions from '../Common/FadeTransitions'
import { renderCompanyMap } from './tencentCompanyMap'

const ContactUs = () => {
    const isPc = useMediaQuery(CONFIG.minDeviceWidth);
    const [data, setdata] = useState([]);

    useEffect(() => {
        const fetch = async () => {
            const result = await apiAboutLangjie.fetchContactUs();
            if (result.code === 200) setdata(result.data);
        }
        fetch();
        let destroyMap = () => {};
        let cancelled = false;
        renderCompanyMap({
            containerId: 'addrMapContainer',
            mapKey: CONFIG.tencentMapKey,
        }).then((destroy) => {
            if (cancelled) {
                destroy();
                return;
            }
            destroyMap = destroy;
        });
        return () => {
            cancelled = true;
            destroyMap();
        };
    }, []);

    const renderData= () => {
        if (data.length === 0) return;
        const renderLabel = content => {
            const dataArr = [];
            for(let key in content) {
                let arr = [];
                if (typeof content[key] === 'object') {
                    arr = content[key].map((items, index) => <span style={{marginRight: 12}} key={index}>{items}</span>);
                } else {
                    arr = content[key];
                }
                dataArr.push(
                    <p key={key} style={{display: 'flex'}}>
                        <span style={{whiteSpace: 'nowrap'}}>{key + '：'}</span>
                        <span>{arr}</span>
                    </p>
                );
            }
            return dataArr;
        }
        const resArr = [];
        data.forEach((items, index) => {
            resArr.push(
                <div key={index} style={{marginBottom: 40}}>
                    <h3>{items.name}</h3>
                    <div>{renderLabel(items.content)}</div>
                </div>
            );
        });
        return resArr;
    }

    // 适配移动端排版样式
    const getMapStyle = isPc => {
        const style = {
            border: '1px solid #eee',
            borderRadius: 5,
            height: isPc ? 470 : 400,
        };
        if (isPc) {
            style.flex = 1;
            style.marginLeft = 20;
        }
        return style;
    }

    return (
        <FadeTransitions>
            <div style={{display: 'flex', flexDirection: isPc ? 'row' :'column'}}>
                <div>{ renderData() }</div>
                <div id={'addrMapContainer'} style={getMapStyle(isPc)}></div>
            </div>
        </FadeTransitions>
    );
}

export default ContactUs;